import styled from "styled-components";


export const Form = styled.form`

`

export const Input = styled.input`
`

export const SubmitButton = styled.button`
`